import { FC, forwardRef, useEffect, useImperativeHandle, useState } from "react"
import { useParams } from "react-router-dom"
import {
  Alert,
  AlertColor,
  Box,
  Button,
  Chip,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
} from "@mui/material"
import ClearIcon from "@mui/icons-material/Clear"
import { styled } from "@mui/material/styles"
import {
  attachmentModule,
  caseManagement,
  EArchType,
  orderView,
  stageControl,
  stagingManager,
  toothMovement,
  viewControlInTreatment,
  viewEdit,
  wasmModule,
} from "@/gluelayer"
import { isEmpty } from "lodash"

import { useAppDispatch, useAppSelector, useDeepEffect } from "@/core/app/hooks"
import { UText } from "@/components/index"
import { RootState } from "@/core/app/store"
import {
  getQuotation,
  getStageDetailApi,
} from "../../../core/app/slices/order/orderThunkApi"
import { getQuoteRequestObj } from "@/modules/Patient/PatientList/util/commonUtil"
import { refinementModule } from "@/gluelayer/core/modules/refinement/index"
import { setRefinementNum, setSelectStageInPrint } from "@/UDTreat/udTreatSlice"

import orderandprint from "../../../assets/svgs/stagebg.svg"
const BaseButton = styled(Button)({
  width: 34,
  height: 34,
  minWidth: 34,
  padding: 0,
  color: "rgba(0, 0, 0, 0.87)",
  border: "1px solid",
  borderRadius: 4,
  position: "relative",
})
let runStageListen
const SelectStage = () => {
  const { caseId, patientId } = useParams()
  const dispatch = useAppDispatch()
  const [upperStage, setupperStage] = useState<
    { stepindex: number; name: string }[]
  >([])
  const [lowerStage, setlowerStage] = useState<
    { stepindex: number; name: string }[]
  >([])
  const { refinementNum } = useAppSelector(
    (state: RootState) => state.udTreatService,
  )
  const [up_current, setup_current] = useState(0)
  const [down_current, setdown_current] = useState(0)

  const [printedStage, setprintedStage] = useState<{
    up: number[]
    low: number[]
  }>({
    up: [],
    low: [],
  })

  const [orderStage, setorderStage] = useState<{ up: number[]; low: number[] }>(
    {
      up: [],
      low: [],
    },
  )
  const [selectedStage, setselectedStage] = useState<{
    up: number[]
    low: number[]
  }>({
    up: [],
    low: [],
  })
  // =0:initial case; >0: refinement case
  const [refinements, setrefinements] = useState(null)

  const [firstStage, setfirstStage] = useState<{ up: number; low: number }>({
    up: null,
    low: null,
  })
  const [lastStage, setlastStage] = useState<{ up: number; low: number }>({
    up: null,
    low: null,
  })
  const [attachment, setattachment] = useState<{ up: number; low: number }>({
    up: null,
    low: null,
  })
  const [isControl, setisControl] = useState(false)
  const [retainers, setretainers] = useState<{ up: number; low: number }>({
    up: 0,
    low: 0,
  })
  const [isQuick3, setisQuick3] = useState(false)
  const {
    orderService: {
      stageDetail,
      alignerOrderPayload: { stage },
    },
    clinicalService: { zipNames, zipList, refinementFiles },
  } = useAppSelector((state: RootState) => state)
  const { caseDetail } = useAppSelector((state: RootState) => state.caseService)
  const { printedStageInPrint, openReviewPrint } = useAppSelector(
    (state: RootState) => state.udTreatService,
  )

  const getArch = (udesign_category) => {
    let caseArch = "both",
      UpperType = "A",
      LowerType = "A"

    if (!udesign_category) return caseArch
    UpperType = udesign_category.split("/")[0]

    LowerType = udesign_category.split("/")[1]

    if (UpperType.includes("--")) {
      caseArch = "lower"
    } else if (LowerType.includes("--")) {
      caseArch = "upper"
    }

    return { caseArch, UpperType, LowerType }
  }

  useEffect(() => {
    // setprintedStage(printedStageInPrint)
    setselectedStage({ up: [], low: [] })
  }, [printedStageInPrint])
  useEffect(() => {
    dispatch(setSelectStageInPrint(selectedStage))
  }, [selectedStage])
  // get stageDetail
  useDeepEffect(() => {
    const attachmentModule = wasmModule.statusController.GetAttachmentModel()
    const upTempIndex = attachmentModule.GetAttachmentFirstStage(
      wasmModule.module.ArchType.UpArch,
    )
    const lowerTempIndex = attachmentModule.GetAttachmentFirstStage(
      wasmModule.module.ArchType.DownArch,
    )
    setattachment({
      up: upTempIndex,
      low: lowerTempIndex,
    })
    dispatch(getStageDetailApi({ caseId, patientId }))
  }, [])
  const checkStageDifferencesForQuote = (
    upperStage: { stepindex: number; name: string }[],
    lowerStage: { stepindex: number; name: string }[],
  ) => {
    if (!caseDetail?.id) return
    const wasmUpper = Number(upperStage[upperStage.length - 1]?.name || 0)
    const wasmLower = Number(lowerStage[lowerStage.length - 1]?.name || 0)
    const plannedUpper = Number(caseDetail?.planned_upper || 0)
    const plannedLower = Number(caseDetail?.planned_lower || 0)
    console.log(
      "wasm:",
      wasmUpper,
      wasmLower,
      "caseStage:",
      plannedUpper,
      plannedLower,
    )
    if (plannedUpper !== wasmUpper || plannedLower !== wasmLower) {
      console.log("getQuotation11111111111")
      dispatch(
        getQuotation({
          payload: getQuoteRequestObj(caseDetail, {
            upper: wasmUpper,
            lower: wasmLower,
          }),
          isQuoteUpdate: true,
        }),
      )
    }
  }

  /**
   * 监听ctrl键
   */
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Control") {
        setisControl(true)
      }
    }
    const handleKeyUp = (event: KeyboardEvent) => {
      if (event.key === "Control") {
        setisControl(false)
      }
    }
    window.addEventListener("keydown", handleKeyDown)
    window.addEventListener("keyup", handleKeyUp)

    return () => {
      window.removeEventListener("keydown", handleKeyDown)
      window.removeEventListener("keyup", handleKeyUp)
    }
  }, [])

  useEffect(() => {
    if (openReviewPrint) {
      setfirstStage({ low: null, up: null })
      setlastStage({ low: null, up: null })
    } else {
      // refresh the stageDetail when openReviewPrint is closed
      dispatch(getStageDetailApi({ caseId, patientId }))
    }
  }, [openReviewPrint])

  /**
   *  解析stageDetail，赋予stage状态
   */
  useEffect(() => {
    if (isEmpty(stageDetail)) return
    let currentStage = []

    let refinementCount = 0
    if (refinementNum === 0) {
      if (!refinementModule) return
      const refinementHistoryList = refinementModule.getRefinementDateInfo()
      refinementCount = Object.keys(refinementHistoryList).length
      dispatch(setRefinementNum(refinementCount))
      setrefinements(refinementCount - 1)
    } else {
      refinementCount = refinementNum
      setrefinements(refinementNum - 1)
    }
    const { jointUpKeypoints, jointLowerKeypoints } =
        stagingManager.wasmStageData,
      up_res = [],
      low_res = []
    if (refinementCount === 0) return
    const refines = refinementCount - 1
    if (refines > 0) {
      const name = "C" + refines
      currentStage = stageDetail[name] || []
    }
    jointUpKeypoints.forEach((item) => {
      if (item.name.includes("R")) up_res.push({ ...item, name: "0" })
      else up_res.push(item)
    })
    jointLowerKeypoints.forEach((item) => {
      if (item.name.includes("R")) low_res.push({ ...item, name: "0" })
      else low_res.push(item)
    })
    if (refines === 0) {
      currentStage = stageDetail?.initial || []
    }
    setupperStage(up_res)
    setlowerStage(low_res)
    // checkStageDifferencesForQuote(up_res, low_res)
    setup_current(Number(up_res[up_res.length - 1]?.name) || 0)
    setdown_current(Number(low_res[low_res.length - 1]?.name) || 0)
    let upper_print = [],
      upper_order = [],
      lower_print = [],
      lower_order = []

    for (let index = 0; index < currentStage.length; index++) {
      const { arch_type, stage, status } = currentStage[index]
      if (arch_type === 0) {
        if (status === "IN_OFFICE") {
          upper_print = [...upper_print, stage]
          if (stage > 500) {
            upper_print.push(500)
          } else if (stage >= 400) {
            upper_print.push(400)
          }
        }
        if (status === "PREVIOUSLY_ORDERED") {
          upper_order = [...upper_order, stage]
          if (stage > 500) {
            upper_order.push(500)
          } else if (stage >= 400) {
            upper_order.push(400)
          }
        }
      } else {
        if (status === "IN_OFFICE") {
          lower_print = [...lower_print, stage]
          if (stage > 500) {
            lower_print.push(500)
          } else if (stage >= 400) {
            lower_print.push(400)
          }
        }
        if (status === "PREVIOUSLY_ORDERED") {
          lower_order = [...lower_order, stage]
          if (stage > 500) {
            lower_order.push(500)
          } else if (stage >= 400) {
            lower_order.push(400)
          }
        }
      }
    }
    setprintedStage({ up: upper_print, low: lower_print })
    setorderStage({ up: upper_order, low: lower_order })
  }, [stageDetail])
  // stage component
  const stageComponent = (
    upperarch = true,
    upperStage,
    lowerStage,
    retainers,
    selectedStage,
    attachment,
  ) => {
    const stageListComponent = [],
      stageNumber = upperarch ? upperStage.length : lowerStage.length,
      stage = upperarch ? upperStage : lowerStage,
      retainer = upperarch ? retainers.up : retainers.low,
      selected = upperarch ? selectedStage.up : selectedStage.low,
      Tattachment = upperarch ? attachment.up : attachment.low,
      isRetainerArch = upperarch
        ? getArch(caseDetail.udesign_category).UpperType === "R"
        : getArch(caseDetail.udesign_category).LowerType === "R"
    // let Crefinement = ""
    let index = 1
    // const [{ name: name0 } = { name: "" }] = stage

    // if (refinements > 0) {
    //   // 是否是 refinement case
    //   Crefinement = name0
    // }
    // attachement是否在0 stage
    if (Tattachment === 0 && stageNumber > 0) {
      stageListComponent.push(
        stageStatusMap({
          stageStatus: getStepStatus(400, upperarch),
          index: 400,
          upperarch,
        }),
      )
    }
    // 非 retainer arch
    if (!isRetainerArch) {
      for (; index < stageNumber; index++) {
        const { name } = stage[index]
        const numericName = Number(name)
        const isLastStage = index === stageNumber - 1
        const isAttachmentMatched =
          Tattachment > 0 && Number(stage[Tattachment]?.name) === numericName

        // 插入T阶段（attachment stage 前加一阶段）
        if (isAttachmentMatched) {
          stageListComponent.push(
            stageStatusMap({
              stageStatus: getStepStatus(400, upperarch),
              index: 400,
              upperarch,
            }),
          )
        }

        // 最后一步特殊处理
        if (isLastStage) {
          if (Tattachment < 0) {
            // 没有 T，最后一步是 R
            stageListComponent.push(
              stageStatusMap({
                stageStatus: getStepStatus(numericName, upperarch),
                index: numericName,
                upperarch,
                isRetainerStage: true,
              }),
            )
          } else {
            stageListComponent.push(
              stageStatusMap({
                stageStatus: getStepStatus(numericName, upperarch),
                index: name,
                upperarch,
              }),
            )
          }
        } else {
          // 普通步骤
          stageListComponent.push(
            stageStatusMap({
              stageStatus: getStepStatus(numericName, upperarch),
              index: name,
              upperarch,
            }),
          )
        }
      }
    }
    const hasJaw = upperarch
      ? wasmModule.getArchModel(EArchType.UpArch)
      : wasmModule.getArchModel(EArchType.LowArch)

    // +should add  RT or R stage
    const shouldAddRStage =
      stageNumber >= 0 && !(stageNumber > 0 && Tattachment < 0) && hasJaw

    const isRT = Tattachment === 0 && stageNumber === 0
    if (shouldAddRStage) {
      stageListComponent.push(
        stageStatusMap({
          stageStatus: getStepStatus(isRT ? 400 : 500, upperarch),
          index: isRT ? 400 : 500,
          upperarch,
          isRt: isRT,
        }),
      )
    }

    return (
      <Box sx={{ marginTop: "16px", marginBottom: "32px" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: 38,
            lineHeight: 38,
            width: "100%",
          }}
        >
          <Box display={"flex"} alignItems={"center"}>
            <UText variant="subtitle2">
              {upperarch ? "Upper arch" : "Lower arch"}
            </UText>
          </Box>

          <Box display={"flex"}>
            {selected.length > 0 && (
              <Chip
                deleteIcon={<ClearIcon />}
                label="Clear All"
                sx={{
                  marginRight: 1,
                  padding: "6px 12px 6px 16px",
                  color: "rgba(0, 0, 0, 0.87)",
                  border: "none",
                  borderRadius: "4px",
                  background: "var(--grey-300, #E0E0E0)",
                  boxshadow:
                    "0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.20)",
                  "& .MuiChip-label": {
                    padding: "0",
                    fontWeight: "500",
                  },
                  "& .MuiSvgIcon-root": {
                    color: "rgba(0, 0, 0, 0.87)",
                    margin: "0 0 0 8px",
                    fontSize: "20px",
                  },
                }}
                onDelete={() => {
                  if (upperarch) {
                    setselectedStage({ low: selectedStage.low, up: [] })
                    setretainers({ low: retainers.low, up: 0 })
                    setfirstStage({ up: null, low: firstStage.low })
                  } else {
                    setselectedStage({ up: selectedStage.up, low: [] })
                    setretainers({ low: 0, up: retainers.up })
                    setfirstStage({ low: null, up: firstStage.up })
                  }
                }}
                onClick={() => {
                  if (upperarch) {
                    setselectedStage({ low: selectedStage.low, up: [] })
                    setretainers({ low: retainers.low, up: 0 })
                    setfirstStage({ up: null, low: firstStage.low })
                  } else {
                    setselectedStage({ up: selectedStage.up, low: [] })
                    setretainers({ low: 0, up: retainers.up })
                    setfirstStage({ low: null, up: firstStage.up })
                  }
                }}
              />
            )}
            <ToggleButtonGroup size="small">
              {/* <ToggleButton
                size="small"
                value={"SPRINT 24"}
                disabled={stageNumber < 25}
                onClick={() => {
                  const res = []
                  stage.forEach((item) => {
                    if (item.stepindex < 25) {
                      if (item.stepindex !== 0) res.push(Number(item.name))
                      if (stage[Tattachment]?.name === item.name) res.push(400)
                    }
                  })
                  if (upperarch) {
                    setselectedStage({ low: selectedStage.low, up: res })
                  } else {
                    setselectedStage({ up: selectedStage.up, low: res })
                  }
                }}
              >
                SPRINT 24
              </ToggleButton> */}
              <ToggleButton
                size="small"
                value={"SELECT ALL"}
                sx={{
                  padding: "6px 16px",
                  color: "rgba(0, 0, 0, 0.87)",
                  border: "none",
                  borderRadius: "4px",
                  background: "var(--grey-300, #E0E0E0)",
                  boxshadow:
                    "0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.20)",
                }}
                onClick={() => {
                  const res = []
                  const filterStage = []
                  // const  filterStage = upperarch
                  //     ? [...printedStage.up, ...orderStage.up]
                  //     : [...printedStage.low, ...orderStage.low]

                  stage.forEach((item) => {
                    if (
                      item.name !== "0" &&
                      !filterStage.includes(item.stepindex)
                    )
                      res.push(Number(item.name))
                  })

                  // push T stage
                  if (Tattachment >= 0 && !filterStage.includes(400)) {
                    res.unshift(400)
                  }
                  // push Rt or R stage
                  if (
                    (Tattachment >= 0 && stageNumber > 0) ||
                    stageNumber === 0
                  ) {
                    res.push(500)
                  }

                  // remove 500 if res only has 400 and 500
                  if (
                    res.indexOf(400) !== -1 &&
                    res.indexOf(500) !== -1 &&
                    res.length === 2
                  ) {
                    res.pop()
                  }

                  if (upperarch) {
                    setselectedStage({ low: selectedStage.low, up: res })
                  } else {
                    setselectedStage({ up: selectedStage.up, low: res })
                  }
                }}
                disabled={!hasJaw}
              >
                {`SELECT ALL`}
                {/* SELECT ALL ALIGNERS */}
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>
        </Box>
        <Box
          display={"flex"}
          flexWrap={"wrap"}
          sx={{
            marginTop: "16px",
            padding: "0 !important",
            marginBottom: 0,
          }}
        >
          {stageListComponent}
        </Box>
        {/* <Box>
          <UText variant="caption">Add extra retainers</UText>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            border: "1px solid rgba(0, 0, 0, 0.56)",
            width: "fit-content",
            borderRadius: "4px",
          }}
        >
          <Button
            sx={{
              width: 34,
              height: 34,
              minWidth: 34,
              color: "rgba(0, 0, 0, 0.56)",
            }}
            onClick={() => {
              if (upperarch) setretainers({ ...retainers, up: retainer - 1 })
              else setretainers({ ...retainers, low: retainer - 1 })
            }}
            disabled={retainer === 0 || selected.indexOf(500) === -1}
          >
            -
          </Button>
          <Box
            sx={{
              fontSize: 14,
              fontWeight: 500,
              width: 34,
              height: 34,
              textAlign: "center",
              lineHeight: "34px",
              color:
                retainer !== 0 ? "rgba(76, 175, 80, 1)" : "rgba(0, 0, 0, 0.56)",
            }}
          >
            {retainer}
          </Box>
          <Button
            sx={{
              width: 34,
              height: 34,
              minWidth: 34,
              color: "rgba(0, 0, 0, 0.56)",
            }}
            onClick={() => {
              if (upperarch) setretainers({ ...retainers, up: retainer + 1 })
              else setretainers({ ...retainers, low: retainer + 1 })
            }}
            disabled={selected.indexOf(500) === -1}
          >
            +
          </Button>
        </Box> */}
      </Box>
    )
  }
  /**
   * find the component by the stage status
   * @param param0
   * @returns
   */
  const stageStatusMap = ({
    stageStatus,
    index,
    upperarch,
    isRetainerStage = false, //whether the stage is the last one
    isRt = false, // whether the stage is RT
  }) => {
    const getLabel = () => {
      if (isRetainerStage) return index + "/R"
      if (index === 500) return "R"
      if (index === 400) return isRt ? "R" : "T"
      return index
    }

    const commonProps = {
      onClick: () => stageHandle({ index, upperarch }),
      sx: {
        marginRight: 1,
        marginBottom: 1,
        boxShadow: "none",
      },
    }

    const statusMap = {
      ordered: {
        variant: "contained",
        sx: {
          backgroundColor: "#03A9F4",
          borderColor: "rgba(2, 136, 209, 0.50)",
          "&:hover": {
            backgroundColor: "rgba(2, 136, 209, 0.30)",
            borderColor: "#0288D1",
          },
        },
      },
      printed: {
        variant: "contained",
        sx: {
          backgroundColor: "#78909C",
          borderColor: "#546E7A",
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.08)",
          },
        },
      },
      "order&print": {
        variant: "contained",
        sx: {
          backgroundImage: `url(${orderandprint})`,
          borderColor: "rgba(66, 165, 245, 1)",
          "&:hover": {},
        },
      },
      selected: {
        variant: "contained",
        sx: {
          backgroundColor: "#4CAF50",
          color: "#FFFFFF",
          "&:hover": {
            backgroundColor: "#4CAF50",
          },
        },
      },
      disable: {
        variant: "outlined",
        disabled: true,
        sx: {
          backgroundColor: "#FFFFFF",
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.04)",
          },
        },
      },
      default: {
        variant: "outlined",
        sx: {
          backgroundColor: "#FFFFFF",
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.04)",
          },
        },
      },
    }

    const currentStatus = statusMap[stageStatus] || statusMap.default

    return (
      <BaseButton
        key={index}
        {...commonProps}
        {...currentStatus}
        sx={{ ...commonProps.sx, ...currentStatus.sx }}
      >
        {getLabel()}
        {isRt && (
          <Box
            sx={{
              position: "absolute",
              top: -4,
              left: 4,
            }}
          >
            <Typography
              variant="caption"
              fontWeight="bold"
              fontSize={12}
              color="red"
            >
              T
            </Typography>
          </Box>
        )}
      </BaseButton>
    )
  }

  /**
   * stage button click
   * @param upperarch: true/false
   * @param index: current selected tooth id
   * @returns
   */
  const stageHandle = ({ upperarch, index: _index }) => {
    const selected = upperarch ? selectedStage.up : selectedStage.low,
      firstSelectedStage = upperarch ? firstStage.up : firstStage.low,
      lastSelectedStage = upperarch ? lastStage.up : lastStage.low,
      Tattachment = upperarch ? attachment.up : attachment.low,
      index = Number(_index)

    let res = [],
      stage = upperarch ? upperStage : lowerStage

    if (stage.length === 0) {
      stage = [{}, { name: "0", stepindex: 0 }]
    }

    if (isControl) {
      // 按住ctrl键
      // index是已选的stage
      if (selected.indexOf(index) !== -1) {
        res = selected.filter((element) => {
          return element !== index
        })
        upperarch
          ? setselectedStage({
              low: selectedStage.low,
              up: res,
            })
          : setselectedStage({
              up: selectedStage.up,
              low: res,
            })
      } else {
        // index是未选择的stage
        res = [...selected, index]
        upperarch
          ? setselectedStage({
              low: selectedStage.low,
              up: res,
            })
          : setselectedStage({
              up: selectedStage.up,
              low: res,
            })
      }
    } else {
      // 点击第一个stage
      if (!firstSelectedStage) {
        upperarch
          ? setfirstStage({ low: firstStage.low, up: index })
          : setfirstStage({ up: firstStage.up, low: index })
        // index已选过
        if (selected.indexOf(index) !== -1) {
          res = [index]
        } else {
          // index未选过
          res = [...selected, index]
        }

        upperarch
          ? setselectedStage({
              low: selectedStage.low,
              up: res,
            })
          : setselectedStage({
              up: selectedStage.up,
              low: res,
            })
      }
      // 点击第二个stage
      else if (firstSelectedStage && firstSelectedStage !== index) {
        upperarch
          ? setlastStage({ low: lastStage.low, up: index })
          : setlastStage({ up: lastStage.up, low: index })

        let stage1 = firstSelectedStage,
          stage2 = index

        if (firstSelectedStage === 400) {
          res.push(400)
          stage1 = Tattachment === 0 ? 1 : Tattachment
          stage1 = Number(stage[stage1].name)
        }

        if (index === 400) {
          res.push(400)
          stage2 = Tattachment === 0 ? 1 : Tattachment - 1
          stage2 = Number(stage[stage2].name)
        }

        if (firstSelectedStage === 500) {
          res.push(500)
          stage1 = Number(stage[stage.length - 1].name)
        }

        if (index === 500) {
          res.push(500)
          stage2 = Number(stage[stage.length - 1].name)
        }

        if (stage1 > stage2) [stage1, stage2] = [stage2, stage1]

        for (let i = stage1; i < stage2 + 1; i++) {
          // const alreadyPrinted =
          //   (upperarch && printedStage.up.includes(i)) ||
          //   (!upperarch && printedStage.low.includes(i))

          // if (alreadyPrinted) continue

          if (
            Tattachment !== -1 &&
            i === Number(stage[Tattachment].name) &&
            i !== stage1
          ) {
            res.push(400)
          }
          res.push(i)
        }

        res = Array.from(new Set([...selected, ...res])).filter((item) => {
          return item !== 0
        })

        upperarch
          ? setselectedStage({
              low: selectedStage.low,
              up: res,
            })
          : setselectedStage({
              up: selectedStage.up,
              low: res,
            })

        upperarch
          ? setfirstStage({ low: lastStage.low, up: null })
          : setfirstStage({ up: lastStage.up, low: null })
        upperarch
          ? setlastStage({ low: lastStage.low, up: null })
          : setlastStage({ up: lastStage.up, low: null })
      } else if (firstSelectedStage === index) {
        // 重复点击同一个stage
        const res = selected.filter((item) => {
          return item !== index
        })

        if (upperarch) {
          setselectedStage({
            low: selectedStage.low,
            up: res,
          })
          setfirstStage({ low: null, up: null })
          setlastStage({ low: null, up: null })
        } else {
          setselectedStage({
            up: selectedStage.up,
            low: res,
          })
          setfirstStage({ up: null, low: null })
          setlastStage({ low: null, up: null })
        }
      }
    }
    if (res.indexOf(500) === -1) {
      // unselected R
      upperarch
        ? setretainers({ low: retainers.low, up: 0 })
        : setretainers({ low: 0, up: retainers.up })
    }
  }
  /**
   *
   * @param index  number
   * @param upperarch boolean
   * @returns
   */
  const getStepStatus = (index, upperarch) => {
    const ordered = upperarch ? orderStage.up : orderStage.low,
      printed = upperarch ? printedStage.up : printedStage.low,
      selected = upperarch ? selectedStage.up : selectedStage.low

    let stageStatus = "default"
    // ordered
    if (ordered.indexOf(Number(index)) !== -1) {
      stageStatus = "ordered"
    }
    // printed
    if (printed.indexOf(Number(index)) !== -1) {
      stageStatus !== "ordered"
        ? (stageStatus = "printed")
        : (stageStatus = "order&print")
    }

    if (!isEmpty(selected) && selected.indexOf(Number(index)) !== -1) {
      stageStatus = "selected"
    }
    if (isQuick3 && [0, 1, 2].indexOf(index) !== -1) {
      stageStatus = "disable"
    }
    return stageStatus
  }
  return (
    <>
      <Box id="stageBox">
        <Box sx={{ padding: "16px 0", marginTop: "20px" }}>
          <UText variant="h6">Select stages</UText>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: 10,
              float: "right",
              height: "100%",
              color: "rgba(0, 0, 0, 0.87)",
              fontWeight: 500,
            }}
          >
            <Box
              sx={{
                height: 18,
                width: 18,
                backgroundColor: "#78909C",
                borderRadius: 0.5,
                margin: 1,
              }}
            ></Box>
            Previously printed in office
            <Box
              sx={{
                height: 18,
                width: 18,
                backgroundColor: "#03A9F4",
                borderRadius: 0.5,
                margin: 1,
              }}
            ></Box>
            Previously ordered
            <Box
              sx={{
                height: 18,
                width: 18,
                backgroundColor: "#4CAF50",
                borderRadius: 0.5,
                margin: 1,
              }}
            ></Box>
            Current selection
          </Box>
        </Box>
        <Box>
          {
            <Box>
              {stageComponent(
                true,
                upperStage,
                lowerStage,
                retainers,
                selectedStage,
                attachment,
              )}
            </Box>
          }
          {
            <Box sx={{ overflowY: "hidden" }}>
              {stageComponent(
                false,
                upperStage,
                lowerStage,
                retainers,
                selectedStage,
                attachment,
              )}
            </Box>
          }
        </Box>
      </Box>
    </>
  )
}

export default SelectStage
